import React, { createContext, useContext, useState, useCallback } from 'react';

const DrawerContext = createContext();

export const useDrawer = () => useContext(DrawerContext);

export const DrawerProvider = ({ children }) => {
    const [open, setOpen] = useState(false);
    const [content, setContent] = useState(null);
    const [titleDrawer, setTitleDrawer] = useState('');

    const showDrawer = useCallback((component) => {
        setContent(component);
        setOpen(true);
    }, []);

    const hideDrawer = useCallback(() => {
        setOpen(false);
    }, []);

    return (
        <DrawerContext.Provider value={{ open, content, titleDrawer, showDrawer, hideDrawer, setTitleDrawer }}>
            {children}
        </DrawerContext.Provider>
    );
};